import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col h-full min-h-full border border-gray-300" }
const _hoisted_2 = { class: "grid grid-cols-3 h-[52px] min-h-[52px]" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleSearchStartTablet',
  setup(__props) {

const activeTab = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'flex justify-center items-center w-full h-[52px] px-3 font-oswald transition-all duration-300 cursor-pointer',
          activeTab.value === 0 ? 'bg-zbr-primary text-white' : 'text-zbr-gray-900 bg-white border-r border-b border-gray-300'
        ]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 0))
      }, _toDisplayString(_ctx.$t('BIKES-SEARCH-MANUFACTURER-1')), 3),
      _createElementVNode("div", {
        class: _normalizeClass([
          'flex justify-center items-center w-full h-[52px] px-3 font-oswald transition-all duration-300 cursor-pointer',
          activeTab.value === 1 ? 'bg-zbr-primary text-white' : 'text-zbr-gray-900 bg-white border-r border-b border-gray-300'
        ]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 1))
      }, _toDisplayString(_ctx.$t('BIKES-SELECT-TYPE-1')), 3),
      _createElementVNode("div", {
        class: _normalizeClass([
          'flex justify-center items-center w-full h-[52px] px-3 font-oswald transition-all duration-300 cursor-pointer',
          activeTab.value === 2 ? 'bg-zbr-primary text-white' : 'text-zbr-gray-900 bg-white border-b border-gray-300'
        ]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 2))
      }, _toDisplayString(_ctx.$t('SEARCH-HISTORY')), 3)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({
        minHeight: 'calc(100% - 52px)',
      }),
      class: "flex flex-col w-full"
    }, [
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-300",
        "enter-from-class": "opacity-0 transform -translate-y-5",
        "enter-to-class": "opacity-100 transform translate-y-0",
        "leave-active-class": "transition ease-in duration-300",
        "leave-from-class": "opacity-100 transform translate-y-0",
        "leave-to-class": "opacity-0 transform -translate-y-5",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (activeTab.value === 0)
            ? _renderSlot(_ctx.$slots, "tab-0", { key: 0 })
            : (activeTab.value === 1)
              ? _renderSlot(_ctx.$slots, "tab-1", { key: 1 })
              : _renderSlot(_ctx.$slots, "tab-2", { key: 2 })
        ]),
        _: 3
      })
    ], 4)
  ]))
}
}

})